import { c as _c } from "react/compiler-runtime";
import { LocaleEnum } from '@systemeio/ui';
import { useMemo } from 'react';
import { getLanguageCodeByLocale } from 'shared/enums/language-code-enum';
import { AdminRolesEnum, UserRolesEnum } from 'shared/enums/user-roles-enum';
import { UserWorkspaceRolesEnum } from 'shared/enums/user-workspace-roles-enum';
import { UserInterface } from 'shared/types/user-interface';
import { hasWorkspaces } from '../utils/has-workspaces';
import { isSIO } from 'shared/utils/is-sio';
export const useUserStatus = dashboardUser => {
  const $ = _c(42);
  let t0;
  if ($[0] !== dashboardUser?.roles) {
    t0 = dashboardUser?.roles.includes(UserRolesEnum.customer) || false;
    $[0] = dashboardUser?.roles;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCustomer = t0;
  let t1;
  if ($[2] !== dashboardUser?.roles) {
    t1 = dashboardUser?.roles.includes(UserRolesEnum.affiliate) || false;
    $[2] = dashboardUser?.roles;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isAffiliate = t1;
  let t2;
  if ($[4] !== dashboardUser?.roles) {
    t2 = dashboardUser?.roles.includes(UserRolesEnum.student) || false;
    $[4] = dashboardUser?.roles;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isStudent = t2;
  const isWorkspaceOwner = dashboardUser ? dashboardUser.workspaceOwner === null : false;
  const isRootAdmin = dashboardUser?.id === 161 || dashboardUser?.workspaceOwner === 161;
  const isWhiteLabelOwner = dashboardUser?.hasWhiteLabel && !isRootAdmin || false;
  const isSupportImpersonation = !!dashboardUser?.impersonator && dashboardUser.impersonator.id !== dashboardUser.mainUser?.user.id;
  const isSubAccountImpersonation = dashboardUser?.id !== dashboardUser?.mainUser?.user.id;
  let t3;
  if ($[6] !== dashboardUser?.roles) {
    t3 = adminRoles => (adminRoles || Object.values(AdminRolesEnum)).filter(el => dashboardUser?.roles.includes(el)).length !== 0;
    $[6] = dashboardUser?.roles;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const checkAdminRoles = t3;
  let t4;
  if ($[8] !== isSubAccountImpersonation) {
    t4 = !isSubAccountImpersonation && isSIO();
    $[8] = isSubAccountImpersonation;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const shouldShowSubAccountPage = t4;
  let t5;
  if ($[10] !== dashboardUser?.impersonator?.roles) {
    t5 = adminRoles_0 => (adminRoles_0 || Object.values(AdminRolesEnum)).filter(el_0 => dashboardUser?.impersonator?.roles.includes(el_0)).length !== 0;
    $[10] = dashboardUser?.impersonator?.roles;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const checkImpersonatorAdminRoles = t5;
  let t6;
  if (!isWorkspaceOwner && dashboardUser && hasWorkspaces(dashboardUser)) {
    let t7;
    if ($[12] !== dashboardUser.workspaceMemberships || $[13] !== dashboardUser.workspaceOwner) {
      let t8;
      if ($[15] !== dashboardUser.workspaceOwner) {
        t8 = el_1 => el_1.workspaceOwner.id === dashboardUser.workspaceOwner;
        $[15] = dashboardUser.workspaceOwner;
        $[16] = t8;
      } else {
        t8 = $[16];
      }
      t7 = dashboardUser.workspaceMemberships.find(t8);
      $[12] = dashboardUser.workspaceMemberships;
      $[13] = dashboardUser.workspaceOwner;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const workspace = t7;
    t6 = workspace ? workspace.role === UserWorkspaceRolesEnum.workspaceAdmin : false;
  } else {
    t6 = false;
  }
  const isWsAdmin = t6;
  let t7;
  if (!isWorkspaceOwner && dashboardUser && hasWorkspaces(dashboardUser)) {
    let t8;
    if ($[17] !== dashboardUser.workspaceMemberships || $[18] !== dashboardUser.workspaceOwner) {
      let t9;
      if ($[20] !== dashboardUser.workspaceOwner) {
        t9 = el_2 => el_2.workspaceOwner.id === dashboardUser.workspaceOwner;
        $[20] = dashboardUser.workspaceOwner;
        $[21] = t9;
      } else {
        t9 = $[21];
      }
      t8 = dashboardUser.workspaceMemberships.find(t9);
      $[17] = dashboardUser.workspaceMemberships;
      $[18] = dashboardUser.workspaceOwner;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    const workspace_0 = t8;
    t7 = workspace_0 ? workspace_0.role === UserWorkspaceRolesEnum.workspaceAssistant : false;
  } else {
    t7 = false;
  }
  const isWsAssistant = t7;
  let t8;
  if ($[22] !== dashboardUser?.dashboardLocale) {
    t8 = () => getLanguageCodeByLocale(dashboardUser?.dashboardLocale ?? LocaleEnum.ENGLISH);
    $[22] = dashboardUser?.dashboardLocale;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  dashboardUser?.dashboardLocale;
  let t9;
  if ($[24] !== t8) {
    t9 = t8();
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const intlLocale = t9;
  const isRestrictedUser = dashboardUser?.accessRestricted && isWorkspaceOwner;
  let t10;
  if ($[26] !== checkAdminRoles || $[27] !== checkImpersonatorAdminRoles || $[28] !== intlLocale || $[29] !== isAffiliate || $[30] !== isCustomer || $[31] !== isRestrictedUser || $[32] !== isRootAdmin || $[33] !== isStudent || $[34] !== isSubAccountImpersonation || $[35] !== isSupportImpersonation || $[36] !== isWhiteLabelOwner || $[37] !== isWorkspaceOwner || $[38] !== isWsAdmin || $[39] !== isWsAssistant || $[40] !== shouldShowSubAccountPage) {
    t10 = {
      isCustomer,
      isAffiliate,
      isStudent,
      isWsAdmin,
      isWhiteLabelOwner,
      isWsAssistant,
      isWorkspaceOwner,
      isRootAdmin,
      isSubAccountImpersonation,
      isSupportImpersonation,
      checkAdminRoles,
      checkImpersonatorAdminRoles,
      intlLocale,
      shouldShowSubAccountPage,
      isRestrictedUser
    };
    $[26] = checkAdminRoles;
    $[27] = checkImpersonatorAdminRoles;
    $[28] = intlLocale;
    $[29] = isAffiliate;
    $[30] = isCustomer;
    $[31] = isRestrictedUser;
    $[32] = isRootAdmin;
    $[33] = isStudent;
    $[34] = isSubAccountImpersonation;
    $[35] = isSupportImpersonation;
    $[36] = isWhiteLabelOwner;
    $[37] = isWorkspaceOwner;
    $[38] = isWsAdmin;
    $[39] = isWsAssistant;
    $[40] = shouldShowSubAccountPage;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  return t10;
};